import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { User, X } from 'lucide-react';
const messages = ['Someone in Perth South just requested a quote', 'A homeowner just booked an emergency callout', 'A 5-star Google review just landed', 'A new build lighting upgrade was just booked', 'A hot water emergency was just dispatched'];
export function SocialProofToast() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
    }, 6000);
    return () => clearTimeout(initialDelay);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 4000);
    return () => clearTimeout(hideTimer);
  }, [isVisible, isDismissed]);
  useEffect(() => {
    if (isDismissed || isVisible) return;
    const showNextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % messages.length);
      setIsVisible(true);
    }, 8000);
    return () => clearTimeout(showNextTimer);
  }, [isVisible, isDismissed]);
  if (isDismissed) return null;
  return <div className="fixed bottom-24 md:bottom-8 left-4 md:left-8 z-40 pointer-events-none" data-id="element-473">
      <AnimatePresence data-id="element-474">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 50,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} className="bg-white rounded-xl shadow-xl border border-gray-100 p-3 flex items-center gap-3 max-w-[300px] pointer-events-auto relative" data-id="element-475">
            <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 relative" data-id="element-476">
              <User className="w-5 h-5 text-emerald-600" data-id="element-477" />
              <span className="absolute bottom-0 right-0 w-3 h-3 bg-emerald-500 border-2 border-white rounded-full" data-id="element-478"></span>
            </div>
            <p className="text-xs text-slate font-medium leading-tight pr-4" data-id="element-479">
              {messages[currentIndex]}
            </p>
            <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-480">
              <X className="w-3 h-3" data-id="element-481" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}